<template>
  <local-map-with-sidebar-page class="full-page-with-sidebar"
                               :filtered-boundaries="filteredBoundaries"
                               :filter-options="filterOptions"
                               :organisation-boundaries="organisationBoundaries"
                               :search-strategy="searchStrategy"
                               :show-event-type-filter="showEventTypeFilter"
                               :show-label-filter="showLabelFilter"
                               :show-region-filter="showRegionFilter"
                               :show-type-filter="showTypeFilter">
    <template #sidebar-footer>
      <div v-html="footerMarkup" />
    </template>
  </local-map-with-sidebar-page>
</template>

<script>
import GeoipCountryMixin from '@/location-search/geoip-country-mixin'
import LocalMapWithSidebarPage from './local-map-with-sidebar-page'
import { sharedMapPropsMixin } from './shared-map-props'

export default {
  components: {LocalMapWithSidebarPage},

  mixins: [ GeoipCountryMixin, sharedMapPropsMixin ],

  props: {
    filterOptions: {
      type: Object,
      required: true
    },
    groupCreationAllowed: {
      type: Boolean,
      required: true
    },
    showEventTypeFilter: {
      type: Boolean,
      required: true
    },
    showLabelFilter: {
      type: Boolean,
      required: true
    },
    showRegionFilter: {
      type: Boolean,
      required: true
    },
    showTypeFilter: {
      type: Boolean,
      required: true
    },
    footerMarkup: {
      type: String,
      required: true
    }
  },

  created() {
    this.$store.commit('setEventCreationAllowed', !this.agraConfiguration.disablePublicEventCreation)
    this.$store.commit('setGroupCreationAllowed', this.groupCreationAllowed)
  }
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;

  ::v-deep(.footer) {
    border-top: none;
    padding-bottom: 20px;
  }

  @include breakpoints.screen-md-up {
    ::v-deep(.footer) {
      // Some overrides to use the mobile styling for the footer, since it's in a narrow space
      & > .container {
        width: initial;
        flex-direction: column !important;

        & > .locale-form-wrapper {
          order: 1 !important;
          margin-top: 10px;
        }
      }
    }
  }
</style>
